<template>
  <FloatingCard :feeling="feeling">
    <div class="stack stack--small">
      <p>Importované dokumenty můžete přesunout do jiného šanonu.</p>
      <ContainersList
        v-if="status !== 'documents-moved'"
        :token="token"
        :roomID="roomID"
        name="archive"
        @status-change="updateStatus"
        @container-change="updateSelectedContainer"
      />
      <ButtonComponent
        v-if="selectedContainer"
        label="Archivovat importované dokumenty"
        :disabled="status === 'documents-moved'"
        @click="archiveDocuments"
      />
      <template v-if="status === 'documents-moved' || status === 'something-wrong'">
        <p>{{ result }}</p>
      </template>
    </div>
  </FloatingCard>
</template>

<script>
import FloatingCard from '@/components/FloatingCard';
import ContainersList from '@/components/ContainersList';
import ButtonComponent from '@/components/ButtonComponent';

import DocumentManager from '@/mixins/DocumentManager';

export default {
  name: 'ArchiveCard',
  components: {
    FloatingCard,
    ContainersList,
    ButtonComponent,
  },
  mixins: [
    DocumentManager,
  ],
  props: {
    token: {
      type: String,
    },
    roomID: {
      type: String,
    },
    importResults: {
      type: Object,
    },
  },
  data() {
    return {
      status: '',
      selectedContainer: '',
      result: '',
    };
  },
  computed: {
    feeling() {
      switch (this.status) {
        case 'retrieving-recent-containers':
          return 'pending';
        case 'recent-containers-retrieved':
          return null;
        case 'listing-structure':
          return 'pending';
        case 'structure-listed':
          return null;
        case 'moving-documents':
          return 'pending';
        case 'documents-moved':
          return 'positive';
        case 'something-wrong':
          return 'negative';
        default:
          return null;
      }
    },
  },
  watch: {
    selectedContainer() {
      this.$emit('container-change', this.selectedContainer);
    },
  },
  methods: {
    updateSelectedContainer(payload) {
      this.selectedContainer = payload;
    },
    updateStatus(payload) {
      this.status = payload.status;
    },
    async archiveDocuments() {
      this.status = 'moving-documents';
      try {
        await Promise.all(
          Object.keys(this.importResults).map(async (documentID) => {
            console.log('logg');
            console.log({
              token: this.token,
              document: { id: documentID },
              container: {
                id: this.selectedContainer.id,
                type: this.selectedContainer.type,
              },
            });
            const tralala = await this.$_DocumentManager_moveDocument({
              token: this.token,
              document: { id: documentID },
              container: {
                id: this.selectedContainer.id,
                type: this.selectedContainer.type,
              },
            });
            console.log(tralala);
          }),
        );
        this.status = 'documents-moved';
        this.result = `Dokumenty přesunuty do šanonu ${this.selectedContainer.label}`;
      } catch (error) {
        this.status = 'something-wrong';
        this.result = 'Něco se pokazilo, ozvěte se nám prosím';
        throw error;
      }
    },
  },
  beforeDestroy() {
    this.selectedContainer = '';
  },
};
</script>
